// extracted by mini-css-extract-plugin
export default {"container":"style_container__06ecr","content":"style_content__JeCR+","title":"style_title__mSBX1","title_header":"style_title_header__kjt4x","title_inner":"style_title_inner__U-Ueg"};